import { createSignal } from "solid-js"
import type { PlayerIdOrNull } from "../../lib/core/player/PlayerIdOrNull"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

/**
 * The root data store for selection is multi-select.
 * 
 * example usage:
 * export const [getSelectedPositionList, setSelectedPositionList] = useSelectedPositionListSignal(engine)
 */
export const useAuthPlayerIdSignal = createSharedCachedFactory((
  // engine: Engine
) => {

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<PlayerIdOrNull>(null)

  return signal
})


